import request from '../utils/request'

export function getdataInfo(params) {
   return request({
       url:'/esg/generator/esgcontent/info',
       method:'post' ,
       params

   })
}


export function getActivityList(params) {
    return request({
        url:'/esg/generator/esgactivity/list',
        method:'get' ,
        params
 
    })
 }

 export function getActivityInfo(params) {
    return request({
        url:'/esg/generator/esgactivity/info',
        method:'get' ,
        params
 
    })
 }